<template>
  <div class="rounded-lg bg-accent-50 p-6 text-accent-950 md:p-12">
    <app-page-section
      subtitle="Nos équipes sont à votre écoute pour répondre à tous vos besoins de
        formations"
      title="Vous ne trouvez pas le sujet qui vous intéresse, parlons-en"
    >
      <template #append>
        <growth-contact-button
          origin="catalog"
          origin_page_action="catalog_missing_topic_cta"
          :origin_page_id="catalogPageId"
          size="xl"
        >
          Nous contacter
        </growth-contact-button>
      </template>
    </app-page-section>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  catalogPageId: string;
}>();
</script>
